import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLine2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M270.653 110.017a9.423 9.423 0 0 0-13.246 1.471l-30.278 37.848-48.034-34.935-63.691 53.323-28.61-25.749-59.595 29.797a9.424 9.424 0 0 0 8.428 16.858l48.106-24.053 31.224 28.102L179.91 138.3l50.692 36.866 41.523-51.904a9.423 9.423 0 0 0-1.472-13.245"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M270.695 51.713c-4.045-3.275-9.979-2.65-13.254 1.395l-29.693 36.68-44.271-39.323-69.045 71.781-33.484-27.527-57.201 80.001a9.424 9.424 0 0 0 2.185 13.147c4.234 3.028 10.12 2.049 13.147-2.184l45.474-63.601 31.377 25.795 68.573-71.292 45.48 40.397 42.108-52.015c3.274-4.045 2.65-9.98-1.396-13.254"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLine2;
